import {
    configStringToValidatedCurrencyString,
    currencyStringToValue,
    parseCommaSeperatedNumber,
    roundTo,
    valueToCurrency
} from "./helperFunction";

class TicketFeeData {
    constructor() {
        this.addition = 0;
        this.percent = 0;
    }
}

export default function processTicketFee(price, relevantData, currencyOptions, generalOptions, {ticketFee}, preSalePercent, includingFees) {

    const {ticket_fee_type} = relevantData;

    let ticketFeeData = new TicketFeeData();

    if (ticket_fee_type === 'inapplicable') {
        ticketFee.textContent = generalOptions.nofee;
        return ticketFeeData;
    }

    if (ticket_fee_type === 'fix') {
        ticketFeeData.addition = currencyStringToValue(relevantData.fixed_ticket_fee, currencyOptions, generalOptions);
        ticketFee.textContent = valueToCurrency(getTicketFeeAddition(price, relevantData, currencyOptions, generalOptions, includingFees) + ticketFeeData.addition, currencyOptions, true);
    }

    if (ticket_fee_type === 'variable') {
        ticketFeeData.addition = getTicketFeeAddition(price, relevantData, currencyOptions, generalOptions, includingFees);

        ticketFeeData.percent = getTicketFeePercent(price, relevantData, currencyOptions, generalOptions, includingFees)
        calculateTicketFee(price, relevantData, ticketFeeData, currencyOptions, generalOptions, ticketFee, preSalePercent, includingFees);
    }

    return ticketFeeData;
}

function getTicketFeeAddition(price, relevantData, currencyOptions, generalOptions, includingFees) {
    if (!relevantData.ticket_fee_add_enable || relevantData.ticket_fee_add_enable === "0") {
        return 0;
    }

    if (priceThresholdReached(relevantData, includingFees, currencyOptions, generalOptions, price)  && relevantData.ticket_fee_add_after_threshold !== "") {
        return currencyStringToValue(relevantData.ticket_fee_add_after_threshold, currencyOptions, generalOptions);
    }

    return currencyStringToValue(relevantData.ticket_fee_add, currencyOptions, generalOptions);
}

function getTicketFeePercent(price, relevantData, currencyOptions, generalOptions, includingFees) {

    if (priceThresholdReached(relevantData, includingFees, currencyOptions, generalOptions, price)  && relevantData.variable_ticket_fee_after_threshold !== "") {
        return parseCommaSeperatedNumber(relevantData.variable_ticket_fee_after_threshold);
    }
    return parseCommaSeperatedNumber(relevantData.variable_ticket_fee);
}

function calculateTicketFee(price, relevantData, ticketFeeData, currencyOptions, generalOptions, ticketFee, preSalePercent, includingFees) {
    let result;

    if (includingFees) {
        result = roundTo(((price - ticketFeeData.addition) / (100 + ticketFeeData.percent + preSalePercent)) * ticketFeeData.percent + ticketFeeData.addition, currencyOptions, generalOptions);
    } else {
        result = roundTo(price * (ticketFeeData.percent / 100) + ticketFeeData.addition, currencyOptions, generalOptions);
    }

    result = clampTicketFee(result, relevantData, currencyOptions, generalOptions);

    ticketFee.textContent = valueToCurrency(result, currencyOptions);
}

function clampTicketFee(ticketFeeResult, relevantData, currencyOptions, generalOptions) {
    const minFee = currencyStringToValue(relevantData.min_variable_ticket_fee, currencyOptions, generalOptions);
    const maxFee = currencyStringToValue(relevantData.max_variable_ticket_fee, currencyOptions, generalOptions);

    if (minFee && ticketFeeResult < minFee) {
        return minFee;
    }
    if (maxFee !== 0 && ticketFeeResult > maxFee) {
        return maxFee;
    }
    return ticketFeeResult;
}

function priceThresholdReached(relevantData, includingFees, currencyOptions, generalOptions, price) {

    if (!relevantData.threshold || relevantData.threshold === "0") {
        return false;
    }

    const threshold = includingFees ? currencyStringToValue(relevantData.threshold_including, currencyOptions, generalOptions) : currencyStringToValue(relevantData.threshold_excluding, currencyOptions, generalOptions);

    if (price >= threshold) {
        return true;
    }

    return false;
}
